module.exports = __webpack_public_path__ + "img/handraw_coeur vide copie.d73a7354.svg";